module.exports = __webpack_public_path__ + "static/img/7.1197032.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting602/images/7.png
// module id = agyc
// module chunks = 3